import React, { useState, useEffect, useRef } from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';
import _ from 'lodash';
import useDataApi from '../../utils/useDataApi';
import usePostApi from '../../utils/usePostApi';

import ScheduleEF from './ScheduleEF';
import currencyConversion from '../../utils/currencyConversion';

const type = 'schedule_ef';

export default function (drupalParams) {
  const { case_uuid, canEdit, can_see_details } = drupalParams;
  const [{ data, isLoading, isError }, { setData }] = useDataApi(
    `/ir-search/query-json?query=${type}&case_uuid=${case_uuid}`,
    {}
  );
  const [viewFilters, setViewFilters] = useState({});
  const [editScheduleForm, setEditScheduleForm] = useState(false);
  const inputRef = useRef(null);

  const transformResponseToData = (item) => {
    let schedule = {};
    schedule = Array.isArray(item.queries)
      ? _.get(item, 'queries[0].schedule_ef[0].text', [])
      : _.get(item, 'queries.schedule_ef[0].text', []);

    return schedule;
  };

  const [{ data: savedScheduleResponse, isLoading: isLoadingSave, isError: isSaveError }, setPostData] =
    usePostApi('/scheduleform/save');

  useEffect(() => {
    if (savedScheduleResponse) setData(savedScheduleResponse.content);
  }, [savedScheduleResponse]);

  const toBoolean = (value) => /^true|yes$/i.test(value);

  const saveScheduleForm = (values) => {
    console.log('Got Form Values', values);
    const { priority_creditors = [], non_priority_creditors = [] } = values;
    const creditorsData = {
      priority_creditors: priority_creditors.map((priority_creditor) => ({
        creditor_name: priority_creditor.creditor_name || '',

        creditor_address_street: priority_creditor.creditor_address_street || '',
        creditor_address_city: priority_creditor.creditor_address_city || '',
        creditor_address_state: priority_creditor.creditor_address_state || '',
        creditor_address_zip_code: priority_creditor.creditor_address_zip_code || '',
        creditor_address_country: priority_creditor.creditor_address_country || '',

        is_contingent: toBoolean(priority_creditor.is_contingent),
        is_unliquidated: toBoolean(priority_creditor.is_unliquidated),
        is_disputed: toBoolean(priority_creditor.is_disputed),
        total_claim: currencyConversion.toCentsOrStr(priority_creditor.total_claim),

        priority_amount: currencyConversion.toCentsOrStr(priority_creditor.priority_amount),

        claim_basis: priority_creditor.claim_basis || '',
        account_number_last_4_digits: priority_creditor.account_number_last_4_digits || '',
        usc_subsection: priority_creditor.usc_subsection || '',
        is_subject_to_offset: toBoolean(priority_creditor.is_subject_to_offset),
        debt_date: priority_creditor.debt_date || '',
      })),
      non_priority_creditors: non_priority_creditors.map((non_priority_cred) => ({
        creditor_name: non_priority_cred.creditor_name || '',

        creditor_address_street: non_priority_cred.creditor_address_street || '',
        creditor_address_city: non_priority_cred.creditor_address_city || '',
        creditor_address_state: non_priority_cred.creditor_address_state || '',
        creditor_address_zip_code: non_priority_cred.creditor_address_zip_code || '',
        creditor_address_country: non_priority_cred.creditor_address_country || '',

        is_contingent: toBoolean(non_priority_cred.is_contingent),
        is_unliquidated: toBoolean(non_priority_cred.is_unliquidated),
        is_disputed: toBoolean(non_priority_cred.is_disputed),
        total_claim: currencyConversion.toCentsOrStr(non_priority_cred.total_claim),
        claim_basis: non_priority_cred.claim_basis ? non_priority_cred.claim_basis : '',
        account_number_last_4_digits: non_priority_cred.account_number_last_4_digits || '',
        is_subject_to_offset: toBoolean(non_priority_cred.is_subject_to_offset),
        debt_date: non_priority_cred.debt_date || '',
      })),
    };

    setPostData({
      case_uuid,
      type: 'ef',
      data: creditorsData,
    });
    setEditScheduleForm(false);
  };

  const toggleScheduleForm = () => {
    setEditScheduleForm(!editScheduleForm);
  };

  const onPastedData = (schedule) => {
    setEditScheduleForm(schedule);
  };

  if (isLoading || isLoadingSave) {
    return <ProgressBar now={100} bsStyle="info" label={`${isLoadingSave ? 'Saving in progress' : ''}`} active />;
  }

  if (isError || isSaveError) {
    return <Alert bsStyle="danger">There has been an error {`${isError ? 'loading' : 'saving'}`} Schedule data.</Alert>;
  }
  const scheduleFiltersProps = {
    inputRef,
    viewFilters,
    setViewFilters,
  };

  return (
    <div>
      <ScheduleEF
        schedule={transformResponseToData(data)}
        scheduleFiltersProps={scheduleFiltersProps}
        canEdit={canEdit}
        can_see_details={can_see_details}
        type={type}
        editScheduleForm={editScheduleForm}
        toggleScheduleForm={toggleScheduleForm}
        viewFilters={viewFilters}
        onSubmit={saveScheduleForm}
        onCancel={toggleScheduleForm}
        onPastedData={onPastedData}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_ef/ScheduleEFContainer.jsx